
// Obtiene el mes actual como clave
const getCurrentMonthKey = () => {
  const now = new Date();
  return `${now.getFullYear()}-${now.getMonth() + 1}`; // Ej: "2025-4"
};

// Inicializa o reinicia el contador mensual
const initTransactionCounter = () => {
  const currentMonthKey = getCurrentMonthKey();
  const savedMonthKey = localStorage.getItem("mq_month");

  if (savedMonthKey !== currentMonthKey) {
    localStorage.setItem("mq_transaction_count", "0");
    localStorage.setItem("mq_month", currentMonthKey);
    localStorage.setItem("mq_disabled", "false");
  }

  return parseInt(localStorage.getItem("mq_transaction_count") || "0");
};

// Incrementa la transacción y lanza alerta si llega a 14,500
export const incrementTransaction = () => {
  const currentCount = initTransactionCounter();
  const newCount = currentCount + 1;

  localStorage.setItem("mq_transaction_count", newCount.toString());

  if (newCount === 14500) {
    alert("🚨 You have reached the limit of 14,500 transactions on MapQuest this month.");
    localStorage.setItem("mq_disabled", "true");
    return false;

  }
  return true;
};

// Devuelve el número actual de transacciones de este mes
export const getTransactionCount = () => {
  return initTransactionCounter();
};

// Función global para hacer fetch a MapQuest y contar transacción si es exitosa
export const mapquestFetch = async (url, options = {}) => {

  const isAllowed = localStorage.getItem("mq_disabled") !== "true";
  if (!isAllowed) {
    console.warn("🛑 MapQuest usage is currently disabled due to transaction limit.");
    return Promise.reject("MapQuest disabled");
  }

  try {
    const response = await fetch(url, options);
    if (
      response.ok &&
      typeof url === 'string' &&
      url.includes("mapquestapi.com")
    ) {
      incrementTransaction();
    }
    return response;
  } catch (error) {
    console.error("❌ Error en mapquestFetch:", error);
    throw error;
  }
};
